export const occupations = [
  { id: '0', label: '会社員', value: '0' },
  { id: '1', label: '公務員', value: '1' },
  { id: '2', label: '自営業/個人事業', value: '2' },
  { id: '3', label: '会社役員', value: '3' },
  { id: '4', label: '自由業', value: '4' },
  { id: '5', label: '専業主婦・主夫', value: '5' },
  { id: '6', label: '学生', value: '6' },
  { id: '7', label: 'アルバイト/パート', value: '7' },
  { id: '8', label: '無職', value: '8' },
  { id: '9', label: 'その他', value: '9' },
];
